var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-auto-register"
  }, [_c('div', {
    staticClass: "register-bar",
    on: {
      "click": function click($event) {
        _vm.showAutoRegister = true, _vm.reportUserAnchors('商品拉新页面-会员优惠横条');
      }
    }
  }, [_c('ycf-image', {
    staticClass: "register-bar-icon",
    attrs: {
      "src": "/srcv2/images/redbag_icon.png"
    }
  }), _c('div', {
    staticClass: "register-bar-text"
  }, [_vm._v("成为会员 本单最多省" + _vm._s(_vm._f("filterCommKeepOne")(_vm.saveMoney)))]), _c('i')], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showAutoRegister,
      expression: "showAutoRegister"
    }],
    staticClass: "Layer-FullScreen noticeType-Bulletbox auto-register-box",
    class: {
      'show-animation': _vm.showAutoRegister,
      'fade-out': _vm.showOutAnimation
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.hideBox.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "main-content",
    class: {
      'is-wx': _vm.isWx,
      'is-mini': _vm.isMini
    }
  }, [_vm.qrCodeUrl ? _c('img', {
    staticClass: "register-erweima",
    attrs: {
      "src": _vm.qrCodeUrl
    }
  }) : _vm._e(), _vm._m(0), _vm._m(1)]), _c('div', {
    staticClass: "main-foot"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/auto_register_close_btn.png")
    },
    on: {
      "click": _vm.hideBox
    }
  })])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "txt-p"
  }, [_vm._v("\n          成为会员，高佣产品等你来推；\n          "), _c('br'), _vm._v(" 人气爆品不错过，分享好友必出单；\n          "), _c('br'), _vm._v(" 订单查询及专属售后服务；\n        ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "txt-tips"
  }, [_vm._v("扫码即表示你同意\n          "), _c('a', {
    attrs: {
      "href": "/front/index/serviceAgreement"
    }
  }, [_vm._v("《用户条款》")]), _vm._v("和\n          "), _c('a', {
    attrs: {
      "href": "/front/index/privacyPolicy"
    }
  }, [_vm._v("《隐私政策》")])]);
}];
export { render, staticRenderFns };